import {
  FieldDatePicker,
  FieldNumberInput,
  FieldTextArea,
  FieldTextInput,
  FieldTimeInput,
  FieldMoneyInput,
  FieldHoursInput,
} from '@/components/form/fields';
import { FormSubmitButton } from '@/components/form/formSubmitButton';
import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextInput: FieldTextInput,
    NumberInput: FieldNumberInput,
    TextArea: FieldTextArea,
    TimeInput: FieldTimeInput,
    HoursInput: FieldHoursInput,
    DatePicker: FieldDatePicker,
    MoneyInput: FieldMoneyInput,
  },
  formComponents: {
    SubmitButton: FormSubmitButton,
  },
});
